import { LocalDeviceEvent } from "../LocalDevice";
import { Logger } from "../../Logger";
export class InputPlugin {
    name = "InputPlugin";
    device;
    kind;
    stopListening;
    constructor(kind, device) {
        this.kind = kind;
        this.device = device;
        this.stopListening = this.device.addEventListener(LocalDeviceEvent.StreamChanged, () => {
            let track;
            if (kind === "audio") {
                track = this.device.audioTrack;
            }
            else if (kind === "video") {
                track = this.device.videoTrack;
            }
            Logger.log("[LMM] new input track ", this.kind);
            this.trackChanged(track);
        }, { leading: true });
    }
    processTrack(_track) { }
    stop() {
        this.stopListening();
    }
    debugInfo() {
        return {
            name: "InputPlugin",
            kind: this.kind,
            device: this.device.debugInfo(),
        };
    }
    trackChanged(_track) { }
}
//# sourceMappingURL=InputPlugin.js.map